import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { CropFieldState, CropField } from 'src/app/shared/models';

import { CropFieldActionTypes, CropFieldActions } from '../actions/crop-field.actions';

export const adapter: EntityAdapter<CropField> = createEntityAdapter<CropField>();
export const initialCropFieldState: CropFieldState = adapter.getInitialState({});

export const cropFieldReducer = (
  state = initialCropFieldState,
  action: CropFieldActions,
): CropFieldState => {
  switch (action.type) {
    case CropFieldActionTypes.DeleteCropFieldSuccess: {
      return adapter.removeOne(action.id, state);
    }

    case CropFieldActionTypes.LoadCropFieldsSuccess: {
      const removedState = adapter.removeAll(state);
      return adapter.upsertMany(action.cropFields, removedState);
    }

    case CropFieldActionTypes.LoadLastYearsCropFieldsSuccess: {
      return {
        ...state,
        entitiesLastYear: action.cropFields,
      };
    }

    case CropFieldActionTypes.SetFilteredCropFieldIds: {
      return {
        ...state,
        filteredIds: action.filteredIds,
      };
    }

    case CropFieldActionTypes.PrefillCropField: {
      return {
        ...state,
        isPrefilling: action.isPrefilling,
      };
    }

    case CropFieldActionTypes.UpdateMachiningDepthSuccess: {
      return adapter.updateOne(
        {
          id: action.id,
          changes: { machiningDepthInCentimeters: action.machiningDepthInCentimeters },
        },
        state,
      );
    }

    case CropFieldActionTypes.LoadAgroConnectCustomersSuccess: {
      return {
        ...state,
        agroConnectCustomers: action.agroConnectCustomers,
      };
    }

    case CropFieldActionTypes.IsAwaitingCropFieldsSync: {
      return {
        ...state,
        isAwaitingSync: action.isAwaiting,
      };
    }

    case CropFieldActionTypes.SetCropFieldsSyncId: {
      return {
        ...state,
        syncId: action.syncId,
      };
    }

    default: {
      return state;
    }
  }
};
